"use client";

export function useNextSectionScroll(currentSectionId: string) {
  return () => {
    const currentSection = document.getElementById(currentSectionId);
    if (currentSection) {
      const nextSection = currentSection.nextElementSibling as HTMLElement;
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
}
